import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeExitClearanceDto } from 'src/app/models/EmployeeExitClearanceDto';
import { ExitClearanceApprovalDto } from 'src/app/models/ExitClearanceApprovalDto';
import { PendingExitApprovalModel } from 'src/app/models/PendingExitApprovalModel';
import { approveMovementVm } from 'src/app/models/approveMovementVm';
import { NotificationType } from 'src/app/models/notification.message';
import { ExitClearanceService } from 'src/app/services/exit-clearance.service';
import { NotificationService } from 'src/app/services/notification.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-approve-exit-clearance',
  templateUrl: './approve-exit-clearance.component.html',
  styleUrls: ['./approve-exit-clearance.component.css']
})
export class ApproveExitClearanceComponent implements OnInit {
  currentUser: any;
  Requests: PendingExitApprovalModel[] = [];
  isPendingpprovalModalVisible = false;
  ExitRequest: EmployeeExitClearanceDto  |null =null;
  isCancelVisible:boolean=false;
  ExitRequestApprovals: ExitClearanceApprovalDto[] | undefined;
  MyPendingExitRequestApprovals: ExitClearanceApprovalDto[] | undefined;
  ViewExitRequestVisible = false;
  canPrint: boolean = false;
  isVisible = false;
  // dropdownData = [
  //   { value: 'ID Card to be Returned', options: 'ID Card to be Returned' },
  //   { value: 'Laptop to be Returned', options: 'Laptop to be Returned' },
  //   { value: 'Account Reconciliation to be Completed', options: 'Account Reconciliation to be Completed' },
  //   { value: 'Mobile Phone Reimbursement to be repaid', options: 'Mobile Phone Reimbursement to be repaid' },
  //   { value: 'PPE to be Returned', options: 'PPE to be Returned' },
  //   { value: 'Contact the "Requesting" Team', options: 'Contact the "Requesting" Team' },
  //   { value: 'Exit Medical Waiver/Examination to be Completed', options: 'Exit Medical Waiver/Examination to be Completed' },
  //   { value: 'Vehicle Keys to be Returned', options: 'Vehicle Keys to be Returned' }
  // ];

  // dropdownData = [
  //   { value: 'ID Card to be Returned', options: 'ID Card to be Returned', selected: false },
  //   { value: 'Laptop to be Returned', options: 'Laptop to be Returned', selected: false },
  //   { value: 'Account Reconciliation to be Completed', options: 'Account Reconciliation to be Completed', selected: false },
  //   { value: 'Mobile Phone Reimbursement to be repaid', options: 'Mobile Phone Reimbursement to be repaid', selected: false },
  //   { value: 'PPE to be Returned', options: 'PPE to be Returned', selected: false },
  //   { value: 'Contact the "Requesting" Team', options: 'Contact the "Requesting" Team', selected: false },
  //   { value: 'Exit Medical Waiver/Examination to be Completed', options: 'Exit Medical Waiver/Examination to be Completed', selected: false },
  //   { value: 'Vehicle Keys to be Returned', options: 'Vehicle Keys to be Returned', selected: false }
  // ];
  dropdownData = [
    { value: false, options: 'ID Card to be Returned' },
    { value: false, options: 'Laptop to be Returned' },
    { value: false, options: 'Account Reconciliation to be Completed' },
    { value: false, options: 'Mobile Phone Reimbursement to be repaid' },
    { value: false, options: 'PPE to be Returned' },
    { value: false, options: 'Contact the "Requesting" Team' },
    { value: false, options: 'Exit Medical Waiver yet to be Signed' },
    { value: false, options: 'Examination to be Completed' },
    { value: false, options: 'Vehicle Keys to be Returned' }
  ];


  selectedOption: string[] = [];
  selectedApprovalId: number = 0;

  constructor( private notification: NotificationService,  private router: Router, public datepipe: DatePipe,private userService: UserService, private exitClearanceService:ExitClearanceService) 
  {



   }

  ngOnInit(): void {
      
   this. loadRecords();
  } 
  
 
  handleCommentCancel(): void {
    this.isVisible = false;
  }
  submitForm(): void {
    const formData = this.dropdownData.map((dropdown) => dropdown.value);
    console.log('Form Data:', formData);
    this.isVisible = false;
  }
  handleCancel(): void {
    this.isPendingpprovalModalVisible = false;
    this.isCancelVisible = false;
    
  }

  getStatusColor(status: string): string { 
    switch (status) {
      case "New":
        return 'badge badge-warning';
      case "Pending":
        return 'badge badge-warning';
      case "Approved":
        return 'badge badge-success';
      case "Rejected":
        return 'badge badge-danger';
        case "Closed":
          return 'badge badge-success';
          case "Cancelled":
            return 'badge badge-danger';
      default:
        return 'badge badge-info';
    }}

    downloadExcel() 
    {

    }

    async open(data: PendingExitApprovalModel) 
    {
      this.MyPendingExitRequestApprovals = data.approvals;
     this.ExitRequest =data.exitClearance;
      this.ViewExitRequestVisible = true;
   
  
    }
    async openapproval(data: PendingExitApprovalModel)
    {

      let resRequests = await this.exitClearanceService.GetExitClearanceApprovalByClearance(data.exitClearance.id).toPromise();
      this.ExitRequestApprovals = <ExitClearanceApprovalDto[]>resRequests.responseData;

      this.isPendingpprovalModalVisible = true;
    }
    async loadRecords() {
      ;
      //this.currentUser = this.tokenService.getInfo(); 
      let resRequests = await this.exitClearanceService.getPendingApproval().toPromise();
      this.Requests = <PendingExitApprovalModel[]>resRequests.responseData;
    
    }
    async handleSubmit() {


    }

    close(): void {
      this.ViewExitRequestVisible = false;
      this.canPrint = false;
      
    }

    print(requestReference:EmployeeExitClearanceDto, templateId:string) {
     // this.documentService.DownloadPDF(templateId, `Movement Request - ${requestReference}`);
    }

    async approveRequest(ExitClearanceApproval: ExitClearanceApprovalDto  ) {
      // this.isManPowerpprovalModalVisible = true;
         ; 
         const model: approveMovementVm = { id: ExitClearanceApproval.id,  message: "Approved" };
         
          this.exitClearanceService.approve(model).subscribe({
            next: (data => {
              
              if (data.responseCode == "00") {
                this.notification.sendMessage({
                  message: data.message,
                  type: NotificationType.success
                });
                location.reload();
                this.loadRecords();
                this.close()
              }
              else {
   
                this.notification.sendMessage({
                message: data.message,
                  type: NotificationType.error
                });
   
              }
   
            }),
            error: ((error: any) => {
              console.log(error.error);
              ;
   
   
              this.notification.sendMessage({
                message: error.error.message,
                type: NotificationType.error
              });
            })
   
          });
   
     }

     showCommentModal(approval: { id: number; [key: string]: any }): void {
      this.isVisible = true; 
      this.selectedApprovalId = approval.id; 
    }

    
    onCheckboxChange(option: { value: boolean, options: string }) {
  // When the checkbox is changed, update the selectedOption array
  if (option.value) {
    this.selectedOption.push(option.options);
  } else {
    this.selectedOption = this.selectedOption.filter(item => item !== option.options);
  }
}

     async sendFeedback()  {
     
      
         const model  = { id: this.selectedApprovalId,  message: this.selectedOption.join(', ') };
         
          this.exitClearanceService.feedback(model).subscribe({
            next: (data => {
              
              if (data.responseCode == "00") {
                this.notification.sendMessage({
                  message: data.message,
                  type: NotificationType.success
                });
                this.isVisible = false; 
                
                this.loadRecords();
                this.close()
              }
              else {
   
                this.notification.sendMessage({
                message: data.message,
                  type: NotificationType.error
                });
   
              }
   
            }),
            error: ((error: any) => {
              console.log(error.error);
              ;
   
   
              this.notification.sendMessage({
                message: error.error.message,
                type: NotificationType.error
              });
            })
   
          });
     }
  }
